export default "__VITE_ASSET__qNAy7TPU__"